export default __webpack_public_path__ + "static/media/Multi_entity_registration.fe0bf433.xlsx";